import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {

  static values = {
    resourcesData: Array
  }

  options = {
    chart: {
      height: "100%",
      maxWidth: "100%",
      type: "line",
      fontFamily: "Poppins, sans-serif",
    },
    tooltip: {
      enabled: true,
      shared: true
    },
    series: this.resourcesDataValue,
    stroke: {
      curve: 'smooth'
    },
    xaxis: {
      type: 'datetime',
    },
  }
  
  connect() {
    if (document.querySelector("#line-chart") && typeof ApexCharts !== 'undefined') {
      const myChart = new ApexCharts(document.querySelector("#line-chart"), this.options);
      myChart.render();
    }
  }
}